
/**
  * Do not change! File was auto generate.
  *
  */
import { ReactElement, SVGProps } from 'react';
import { ReactComponent as HomeIconComponent } from "./home-icon.svg";

export const HomeIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <HomeIconComponent {...props} />;
};
